/**
 * The type of route parameter.
 */
export enum RouteParamType {
  Required = 'req',
  Optional = 'opt',
  Wildcard = '*',
}
